import Slide from "./fragments/Slide/Slide";
import Slider from "./fragments/SlidesContainer/SlidesContainer";
import ScrollIntoSlide from "./helpers/scrollIntoSlide";

export default Slider;
export {Slide, ScrollIntoSlide};